export const SURVEY_QUESTIONS = {
    SURVEYOR_DETAILS: {
        NAME: "1. Name of the Surveyor",
        MOBILE_NUMBER: "2. MOBILE NUMBER-",
        DESIGNATION: "3. DESIGNATION-",
        ADDRESS: {
            HOUSE_NO: "4. ADDRESS- House No:",
            LOCALITY: "Locality:",
            TOWN_VILLAGE: "Town/Village:",
            LANDMARK: "Landmark:",
            BLOCK: "Block:",
            DISTRICT: "District:",
            PIN_CODE: "Pin Code:"
        }
    },

    FARMER_DETAILS: {
        NAME: "1. Name of the farmer:",
        ID:"2. Farmer Id:",
        AGE: "3. Age:",
        GENDER: "4. Gender:",
        EDUCATIONAL_QUALIFICATION: "5. Educational Qualification: ",
        ADDRESS:"6.Address",
        MOBILE_NUMBER: "7. Mobile No:",
        PRINCIPAL_OCCUPATION: "8. Principal Occupation:",
        JACKFRUIT_GROWER: "9. Are you a jackfruit grower?"
    },

    PRODUCTION_DETAILS: {
        LAND_OWNERSHIP: "1. Land Ownership:",
        LAND_IN_ACRE: "2. Land in acre:",
        AREA_UNDER_JACKFRUIT: "3. Area under jackfruit (acres):",
        STATE_OF_PLANTATION: "4. State:",
        DISTRICT_OF_PLANTATION: "5. District:",
        TOWN_OF_PLANTATION: "6. Town/Village:",


        SPECIAL_CHARACTERISTICS: {
            QUESTION: "7. Do you have Jackfruit with special/unique characteristics in your orchard or garden?",
            LOCAL_NAME: "7.a. If yes, does this unique variety have a local name?",
            LOCAL_VARIETY_NAME: "7.b. If Yes, name of local variety of jackfruit:"
        },
        AGE_OF_TREES: "8. Approximate age (years) of your Jackfruit trees?",
        NUMBER_OF_TREES: {
            QUESTION: "9. No. of jackfruit trees:",
            SOFT_FLESH: "9.a. How many soft flesh type:",
            FIRM_FLESH: "9.b. How many firm flesh type:"
        },
        PLANTING_MATERIAL_TYPE: "10. Planting material type for growing trees?",
        VARIETY_KNOWN: "11. If budded/grafted plants, do you know the variety? If yes, Variety Name:",
        COST_OF_PRODUCTION: "12. Cost of production:"
    },

    MORPHOLOGICAL_DETAILS: {
        TREE_GROWTH_HABITS: "1. Tree growth habits:",
        APPROXIMATE_HEIGHT: "2. Approximate height of the jackfruit tree:",
        TRUNK_WIDTH: "3. Width of the trunk (wood) of the jackfruit tree(cm):",
        FRUITING_HABIT: "4. Fruiting habit of the tree:",
        FRUITING_SEASON_BEHAVIOR: "5. Fruiting season behavior of the tree in fruiting year?",
        FRUIT_CLUSTERING_HABIT: "6. Fruit clustering habit of the tree?",
        ANNUAL_FRUIT_PRODUCTION: "7. On average, how many fruits does the jackfruit tree produce per year?",
        HARVEST_SEASON_MONTHS: "8. During which month(s) is the harvest season?",
        EXPECTED_YIELD: "9. Expected yield for entire harvest:",
        HARVEST_FREQUENCY: "10. Harvest Frequency: one time/two times/three times",
        JACKFRUIT_SHAPE: "11. Shape of the jackfruit?",
        AVERAGE_FRUIT_SIZE: "12. Average size of the fruits?",
        RIND_COLOR: "13. Color of the Jackfruit rind:",
        BULBS_PER_FRUIT: "14. Number of bulbs per fruit:",
        FRUIT_SIZE:"14.a. Size of the fruit",
        NO_OF_BULBS:"14.b. no. of bulbs",

        FLAVOUR_AT_RIPE: "15. Flavour of the jack fruit at the time of opening of ripe fruit:",
        BULB_COLOR: "16. Color of the bulb?",
        BULB_LENGTH: "17. Length of the bulb:",
        BULB_TEXTURE: "18. Texture of the bulbs?",
        PULP_TASTE: "19. Taste of the pulp:",
        UPLOAD_IMAGES: "20. Add images of your jackfruit tree",
        TO:" to "
    },

    POST_HARVEST_MANAGEMENT: {
        QUANTITY_HARVESTED: "1. Quantity harvested:",
        SELLING_PRICE: "2. Selling price of your jackfruit?",
        TENDER_JACKFRUIT:"2.a Tender JackFruit:",
        MATURE_JACKFRUIT:"2.b Mature JackFruit:",
        RIPE_JACKFRUIT:"2.c Ripe JackFruit:",
        GRADING: "3. Grading done?",
        PACKAGING: "4. Packaging done?",
        VALUE_ADDED_PRODUCTS: "5. Other value-added jackfruit products, if any (jackfruit leather/Jackfruit powder, jackfruit chunks etc.)"
    },

    SALES_MARKET_DETAILS: {
        MARKET_NAME: "Market Name:",
        SELLING_STAGE: "Stage of selling the jackfruit:",
        EXPECTED_PRICE: "Expected price of the fruit:",
        QUANTITY_SOLD: "Quantity sold:",
        PRICE_PER_UNIT: "Price per unit:",
        TRANSPORTATION_MODE: "Transportation Mode:",
        TRANSPORTATION_COST: "Cost of transportation:",
        ROAD_ACCESSIBILITY: "Distance/Road Accessibility",
        COLLECTION_CENTER: "2. Collection centre in your village? ",
        PROCESSING_CENTER: "3. Agro processing centre or any pack house or warehouse in your village?",
        DELIVERY_TO_COLLECTION_CENTER: "4. Are you willing to deliver Jackfruit to local collection center without any damage?",
        MARKET_PROXIMITY: "1. Market proximity:",
        LOCAL:"Local",
        REGIONAL:"Regional",
        NATIONAL:"National",
        INTERNATIONAL:"International"

        },
        
        TRAINING_ASSISTANCE: {
        TRAININGS_ATTENDED: "1. Whether attended trainings on jackfruit processing, if yes please mention(yes/no): ",
        ATTENDED_TRAININGS:"1.a Trainings Attended",
        TRAINING_ORGANIZED:"1.b Training Organized by",
        SHG_FPO_IVCS: "2. Are you part of SHG/FPO/IVCS etc?",
        SHG_NAME:"2.a Name of SHG:",
        FPO_NAME:"2.b Name of FPO:",
        IVCS_NAME:"2.c Name of IVCS:",
        GOVERNMENT_SCHEME: "3. Beneficiary of any Government scheme:",
        SCHEME_NAME:"3.a Name of scheme:",
        SCHEME_DEPARTMENT:"3.b Department/office:",
        SCHEME_DATE_AVAILED:"3.c Date and duration availed:",
        SHG_FORMED: "4. No. of SHG formed:",
        FPO_FORMED: "5. No. of FPO formed:",
        IVCS_FORMED: "6. No. of IVCS formed:",


        },
        
        EXPERT_DETAILS: {
        NAME: "1. Name of the Expert:",
        OCCUPATION: "2. Occupation:",
        DESIGNATION: "3. Designation:",
        BLOCK_TALUKA: "4. Name of the Block/Taluka:",
        MOBILE: "5. Mobile:",
        EMAIL: "6. Email:",
        PROCESSING_ACTIVITIES_REGION: "7. Whether or not activities for processing of jackfruit into value-added products such as Jackfruit Chips, Tender Jackfruit in brine is carried out in the region?",
        INFRASTRUCTURE_FACILITIES: "8. Number of Common Infrastructure facilities Present in the Taluka/Cluster for storing, manufacturing and Marketing of Jackfruit Products.",
        MAJOR_GAPS_INFRASTRUCTURE: "9. Major Gaps in Infrastructure-Storage Facility, Electricity, Roads, Market Yard, Transportation.",
        FIRM_LEVEL_GAPS: "10. Firm Level Gaps-Skill training, Manufacturing practices, Technologies, Finance, Common Infrastructure.",
        FOOD_PROCESSING_CONSTRAINTS: "11. Key constraints for Food processing-Technology, Raw Materials, Common Infrastructure, Support Infrastructure, Finance",
        PROCESSING_UNIT_COLLECTION_CENTER: "12. Is there any processing unit or collection centre in your area?"
        }
        };
        
        export default SURVEY_QUESTIONS;
        